var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-layout-border",class:{ 'wp-layout-border_loading': _vm.loading }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }